import { Filter } from 'react-feather';
import { ButtonComponent } from '@/components/Button/Button';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import { useAppSelector } from '@/app/hooks';
import { Tooltip } from '@mantine/core';

export const FilterButton = ({
  isMoreFilters = true,
  openFilterForm,
  disabled = false,
  disabledTooltip,
}: {
  isMoreFilters?: boolean;
  openFilterForm: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
}) => {
  const intl = useClientTerminology();
  const filterQuery = useAppSelector((state) => state.filterQuery);

  const button = (
    <ButtonComponent
      type="button"
      variant="filter"
      size="sm"
      label={intl.formatMessage({
        id: `analysis.${isMoreFilters ? 'moreFilters' : 'filter'}Button`,
      })}
      data-testid="map-filter-button"
      isSelected={filterQuery.isSelected}
      leftIconComponent={Filter}
      onClick={openFilterForm}
      isDisabled={disabled}
    />
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip label={disabledTooltip} withArrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};
